<template>
  <div class="row" style="height: 100vh">
    <div class="text-h2 text-center pb-8">tabsa-rails</div>
    <form @submit.prevent="submit">
      <input type="text" name="email" v-model="values.email" autocomplete="email" class="mb-4" placeholder="Email" required>
      <input
        :type="show ? 'text' : 'password'"
        :append-inner-icon="show ? 'mdi-eye-off' : 'mdi-eye'"
        @click:append-inner="show = !show"
        name="password"
        v-model="values.password"
        autocomplete="current-password"
        class="mb-4"
        required
      >
      <div class="text-center py-4">
        <button class="block me-4" type="submit">
          Conectar
        </button>
      </div>
    </form>
    <iLink href="#" class="inertia-link text-body-2" as="a">
      Olvide mi contraseña
    </iLink>
  </div>
</template>

<script setup>
import { ref } from "vue"
import Layout from "../../Layouts/minimal.vue";
import { useForm } from "@inertiajs/vue3";
import { usersSessions as sessionsApi } from "../../api";

defineOptions({ layout: Layout });

const show = ref(false);
const values = ref(
  {
    email: "",
    password: ""
  }
);

const submit = async () => {
  const form = useForm({
    user: { ...values.value },
  });

  form.post(sessionsApi.create.path())
};
</script>

<style lang="scss" scoped>
.inertia-link {
  color: #F5F5F5;
  text-decoration-line: none;
}
</style>
